export default __webpack_public_path__ + "static/media/vercel.e939159f.svg";